module.exports = "/assets/56f3453e6edac853eac6ddd4ea8c4544.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/FJ.png
// module id = 2497
// module chunks = 0